import algoliasearch from 'algoliasearch';

export const getSearchIndex = type => {
  const searchClient = algoliasearch('BLB7XGVAAJ', 'f10e059eba37c080aef30f49f75cdbbc');
  const index = searchClient.initIndex(type || 'sms_products_production');
  return index;
};
